// extracted by mini-css-extract-plugin
export default {"content":"Meet_content__61AOV","about":"Meet_about__77EOv"};